<div class="row zone-filter-container mt-4 pb-3 ms-auto me-auto">
  <div class="row zone-filter-title ms-0">
    <h2 class="pt-4 ms-0 ps-0">Filtro de prestadores por zona de acción</h2>
  </div>
  <div class="w-100 p-0 map-body">
    <indu-map
      [center]="center"
      [source]="'supplier'"
      [drawZone]="drawZone"
      [zoom]="10"
      [circleCenter]="circleCenter"
      (setZone)="setfilteredZone($event)"
    ></indu-map>
  </div>
  <div class="row buttons-footer justify-content-end buttons-zone-filter">
    <button id="cancelButton" type="button" class="ind-button-lite" (click)="cancelClick()">
      <span class="text-buttons">Limpiar</span>
    </button>
    <button id="saveButton" type="button" class="ind-button" (click)="onSubmit()">
      <span class="text-buttons">Filtrar</span>
    </button>
  </div>
</div>
